<template>
    <v-button flat dense round color="primary" class="uppercase">
        <img v-if="flags" :src="currentFlag" class="avatar tb-icon-square no-shadow">
        {{ flags ? '' : locale }}
        <q-popover>
            <q-list dense link class="flags">
                <q-item v-for="(localeName, localeKey) in locales" :key="localeKey"
                        v-close-overlay @click.native="setLocale(localeKey)">
                    <q-item-side v-if="flags" :avatar="flagFor(localeKey)" />
                    {{ localeName }}
                    <q-item-side v-if="locale == localeKey" right icon="done" />
                </q-item>
            </q-list>
        </q-popover>
    </v-button>
</template>

<style lang="stylus">
    @import "../../stylus/_variables.styl"

    .flags
        .q-item-avatar
            width $toolbar-icon-height !important
            height $toolbar-icon-height !important

        .q-item-side
            height $toolbar-icon-height !important
</style>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {
        QPopover,
        QList,
        QItem,
        QItemSide
    } from 'quasar-framework'

    export default {
        props: {
            flags: Boolean
        },

        computed: {
            ...mapGetters({
                locale: 'lang/locale',
                locales: 'lang/locales',
            }),
            currentFlag() {
                return this.flagFor(this.locale)
            }
        },

        components: {
            QPopover,
            QList,
            QItem,
            QItemSide
        },

        methods: {
            setLocale (locale) {
                if (this.$i18n.locale !== locale) {
                    loadMessages(locale)

                    this.$store.dispatch('lang/setLocale', {locale})
                }
            },
            flagFor (locale) {
                return `${config.appUrl}${config.devAssetsFolder}/img/locale/${locale}.svg`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LocaleDropdown.vue